import React from "react"
import { useSelector } from "react-redux"

import SmptAndroidPos from "./SmptAndroidPos"
import SmptPcPosCard from "./SmptPcPosCard"
import classes from "./SmptPosList.module.scss"

const SmptPosList = () => {
  const accountId =
    useSelector(state => state.userAccountInfo._id)

  const pcPosTerminals =
    useSelector(state => state.posTerminals[accountId] || [])
      .filter(p => p.type === "pcPos")

  return (
    <div className={classes["row"]}>
      {pcPosTerminals.map((pcPosTerminal, index) =>
        <SmptPcPosCard
          key={index}
          pcPosTerminal={pcPosTerminal}
        />
      )}

      <SmptAndroidPos />
    </div>
  )
}

export default SmptPosList